const en = {
  'Создавайте Telegram-приложения': 'Create Telegram apps',
  'за 10 минут': 'in 10 minutes',
  'Без кода. Без разработчиков.': 'No code. No developers.',
  'Создать приложение бесплатно': 'Create app for free',

  'Готовые шаблоны': 'Ready-made templates',
  'Интернет-магазин с каталогом товаров': 'Online store with a product catalog',
  'Персонализируйте страницу': 'Personalize the page',
  'Настройте блоки под свой бренд и задачи.': 'Customize the blocks for your brand and tasks.',
  'Добавьте товары': 'Add products',
  'Загрузите каталог и подготовьтесь к приёму заказов.': 'Upload a catalog and get ready to accept orders.',
  'Управляйте заказами': 'Manage orders',
  'Все заявки автоматически появляются в панели управления.': 'All requests automatically appear in the dashboard.',

  'Примеры успешных Web Apps': 'Examples of successful Web Apps',
  'Примеры успешных приложений': 'Examples of successful apps',
  'Онлайн-школа иностранных языков': 'Online language school',
  'Страница с услугами сервиса английского языка': 'A page with English language services',
  'Сайт-визитка': 'Business card website',
  'Мини-сайт для презентации компании или бренда': 'A mini-website to present a company or brand',

  'Доставка суши': 'Sushi delivery',
  'Магазин с витриной продукции': 'Store with a product showcase',

  'на период бета-версии': 'for the beta period',
  'Бесплатный тариф': 'Free plan',
  '20+ Web Apps': '20+ Web Apps',
  '20+ приложений': '20+ apps',
  'собственный домен': 'custom domain',
  'интеграции': 'integrations',

  'Ответы на вопросы': 'Answers to questions',
  'Сколько стоит использование Fleep.Apps?': 'How much does Fleep.Apps cost?',
  'Сколько стоит использование Флип.Приложений?': 'How much does Fleep.Apps cost?',
  'Сейчас сервис полностью бесплатный. Вы можете создавать неограниченное количество приложений.': 'The service is currently completely free. You can create an unlimited number of apps.',
  'Нужны ли мне навыки программирования?': 'Do I need programming skills?',
  'Нет, Fleep.Apps создан специально для пользователей без технического бэкграунда. Мы предлагаем интуитивно понятный конструктор и готовые шаблоны. Код писать не потребуется.': 'No, Fleep.Apps is designed for users without a technical background. We offer an intuitive builder and ready-made templates. No code is required.',
  'Нет, Флип.Приложения созданы специально для пользователей без технического бэкграунда. Мы предлагаем интуитивно понятный конструктор и готовые шаблоны. Код писать не потребуется.': 'No, Fleep.Apps is designed for users without a technical background. We offer an intuitive builder and ready-made templates. No code is required.',
  'Как начать пользоваться?': 'How to get started?',
  'по ссылке': 'via link',
  'Нажмите старт в чате с ботом. Откройте и запустите приложение.': 'Press Start in the bot chat. Open and run the app.',
  'Мне нужно больше функций, что делать?': 'I need more features, what should I do?',
  'техническую поддержку': 'technical support',

  'Ваше приложение открывается прямо в': 'Your app opens right in',
  'Без перехода на сайты. Удобно. Нативно.': 'No redirects to websites. Convenient. Native.',

  'Следите за нашими обновлениями и акциями.': 'Follow our updates and promotions.',
  'Перейти в Telegram': 'Go to Telegram',
  'Перейдите в бота': 'Go to the bot',
  'Свои пожелания и вопросы вы всегда можете направить нам в': 'You can always send your wishes and questions to our',

  'Выберите готовый шаблон': 'Choose a ready-made template',
  'Настройте текст и дизайн': 'Customize text and design',
  'Получите ссылку на свое приложение в Telegram': 'Get a link to your app in Telegram',
};

const ru = {};

const translations = { en, ru };
export default translations;
